(function () {
  'use strict';

  function getRequestedContext() {
    try {
      var params = new URLSearchParams(window.location.search);
      var raw = params.get('lxi_image') || params.get('lx_image_context') || '';
      if (!raw) return '';

      return raw
        .trim()
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/['’]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    } catch (e) {
      return '';
    }
  }

  function startContextGalleryWatcher() {
    var requestedImage = getRequestedContext();
    if (!requestedImage) return;

    var contextMarker = 'lxi-context:' + requestedImage;
    var selectionComplete = false;
    var selectionPending = false;
    var observer = null;
    var stopTimer = null;

    function finishSelection() {
      selectionComplete = true;
      selectionPending = false;
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      if (stopTimer) {
        clearTimeout(stopTimer);
        stopTimer = null;
      }
    }

    function findRequestedThumbnail() {
      var thumbnails = document.querySelectorAll('.cl-po--gallery-thumbnail[alt]');
      for (var i = 0; i < thumbnails.length; i++) {
        var alt = (thumbnails[i].getAttribute('alt') || '').toLowerCase();
        if (alt.indexOf(contextMarker) !== -1) return thumbnails[i];
      }

      var galleryImages = document.querySelectorAll('.cl-po--gallery-img[alt]');
      for (var j = 0; j < galleryImages.length; j++) {
        var imageAlt = (galleryImages[j].getAttribute('alt') || '').toLowerCase();
        if (imageAlt.indexOf(contextMarker) === -1) continue;

        var mediaPosition = galleryImages[j].getAttribute('data-media-position');
        if (!mediaPosition) continue;

        var candidates = document.querySelectorAll('.cl-po--gallery-thumbnail[data-media-position]');
        for (var k = 0; k < candidates.length; k++) {
          if (candidates[k].getAttribute('data-media-position') === mediaPosition) return candidates[k];
        }
      }
      return null;
    }

    function trySelectRequestedImage() {
      if (selectionComplete || selectionPending) return;
      var thumbnail = findRequestedThumbnail();
      if (!thumbnail) return;

      var slide = thumbnail.closest('.splide__slide');
      var thumbnailGallery = thumbnail.closest('.cl-po--gallery-thumbnails');
      if (!slide || !thumbnailGallery || !thumbnailGallery.classList.contains('is-initialized')) return;

      if (slide.classList.contains('is-active') || slide.getAttribute('aria-current') === 'true') {
        finishSelection();
        return;
      }

      selectionPending = true;
      slide.click();
      setTimeout(function () {
        if (slide.classList.contains('is-active') || slide.getAttribute('aria-current') === 'true') {
          finishSelection();
        } else {
          selectionPending = false;
          setTimeout(trySelectRequestedImage, 100);
        }
      }, 100);
    }

    trySelectRequestedImage();
    if (selectionComplete) return;

    window.addEventListener('options:rendered', trySelectRequestedImage);

    observer = new MutationObserver(function () {
      trySelectRequestedImage();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    [100, 250, 500, 1000, 2000].forEach(function (delay) {
      setTimeout(trySelectRequestedImage, delay);
    });

    stopTimer = setTimeout(function () {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startContextGalleryWatcher);
  } else {
    startContextGalleryWatcher();
  }
})();
